import { SET_PREFILL_QFF_NUMBER } from 'actions/actionConstants'

const initialState = {
  prefillQFFNumber: null,
}

function tempURLParamsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_PREFILL_QFF_NUMBER:
      return {
        ...state,
        prefillQFFNumber: action.data.prefillQFFNumber,
      }
    default:
      return state
  }
}

export default tempURLParamsReducer
